import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ListView from './views/ListView';
import BaseLayout from '../../components/CabinetBaseLayout';

const Component = () => {
  return (
    <BaseLayout>
      <Switch>
        <Route exact path={''} component={ListView} />
      </Switch>
    </BaseLayout>
  );
};

export default Component;
